export default __webpack_public_path__ + "static/media/image.ab28391f.png";